<script>
import analytic from '@/scripts/libs/analytic';
import VsIcon from './VsIcon';

export default {
  components: {
    VsIcon,
  },
  props: {
    href: {
      type: String,
      default: null,
    },
    to: {
      type: [Object, String],
      default: null,
    },
    type: {
      type: String,
      example: [
        'primary',
        'light',
      ],
      default: undefined,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: undefined,
    },
    size: {
      type: String,
      default: undefined,
    },
    tracker: {
      type: Object,
      default: undefined,
    },
    modern: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonClasses() {
      return [
        this.type,
        this.size,
        this.disabled ? 'disabled' : null,
        this.modern ? null : 'vs-btn',
      ]
        .filter(className => !!className)
        .join(' ');
    },
  },
  methods: {
    $_emitClick(event) {
      this.$emit('click', event);
      if (this.tracker) {
        analytic.send(this.tracker);
      }
    },
  },
  render(h) {
    let renderTag = 'button';
    switch (true) {
      case !!this.to:
        renderTag = 'router-link';
        break;
      case !!this.href:
        renderTag = 'a';
        break;
      default:
        renderTag = 'button';
    }
    const buttonContent = [];

    // Set up loading
    if (this.icon || this.loading) {
      buttonContent.push(h(VsIcon, {
        props: {
          icon: this.loading ? 'loading' : this.icon,
        },
      }));
    }

    // Add slot if slot exist
    if (this.$slots.default) {
      buttonContent.push(
        h(
          'span',
          {
            class: 'vs-button__text cap-first',
          },
          [this.$slots.default],
        ),
      );
    }

    return h(renderTag, {
      class: 'vs-button btn ' + this.buttonClasses,
      attrs: {
        href: this.href,
      },
      on: {
        click: this.$_emitClick,
      },
      props: {
        to: this.to,
      },
    }, buttonContent);
  },
};
</script>

<style lang="scss">
@import '~@/stylesheets/exports/_component-entry';

.vs-button.btn {
  color: $body-color;
  &.light { color: rgba(black, 0.6); }
  &.primary { color: $primary; }
  &.disabled {
    cursor: not-allowed;
  }

  font-size: $font-size-base;
  &.small { font-size: 12px; }
  &.medium { font-size: 24px; }
  &.large { font-size: 36px; }
  &.huge { font-size: 48px; }
}

.vs-button {
  .vs-icon + .vs-button__text {
    margin-left: 0.4em;
  }
}

.vs-button.btn:hover {
  text-decoration: none;
}

// TODO: We may not need this anymore. please check again!
.vs-btn .material-icons + span,
.vs-button__text,
.vs-icon + .vs-button__text {
  font-size: 1em;
  line-height: 0;
}

</style>
